export default __webpack_public_path__ + "static/media/posmenu.a19a8769.svg";